<div class="container">
  <div class="appointment-text page-header" i18n>
    Appointment
  </div>
  <div class="appointment-info-text page-content" i18n>
    Choose a date and time suitable for your appointment.
  </div>

  @if(isPageLoading) {
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  @else if(!isPageLoading) {
  <div class="services-header">
    <div class="service-text" i18n>Services</div>
    <button class="edit-btn" (click)="OnServicechange()" i18n>Edit</button>
  </div>

  @if (isInitialLoadComplete() && selectedServiceListObject?.length != null) {
  <div class="services page-content" i18n>
    @if (selectedServiceListObject?.length === 1) {
      {{ selectedServiceListObject?.length }} service added
    } @else {
      {{ selectedServiceListObject?.length }} services added
    }
  </div>
  }

  <div class="services-chip">
    <mat-chip-set class="selected-chip">
      @for (service of selectedServiceListObject; track trackByServiceId($index, service)) {
      <mat-chip class="custom-chip">{{ service.name }}</mat-chip>
      }
    </mat-chip-set>
  </div>

  <form [formGroup]="resourcesForm">
    <mat-form-field appearance="outline">
      <mat-label i18n>Service advisor</mat-label>
      <mat-select formControlName="serviceadvisorIdControl" (openedChange)="onServiceAdvisorSelect()"
        (selectionChange)="onServiceAdvisorChange($event)">
        <mat-select-trigger>
          {{ getServiceAdvisorName(resourcesForm.get('serviceadvisorIdControl')?.value) }}
        </mat-select-trigger>
        @for (serviceAdvisor of serviceAdvisorList; track trackByResourceId($index, serviceAdvisor)) {
        <mat-option [value]="serviceAdvisor.id">
          <span class="advisor-name">{{ serviceAdvisor.description }}</span>
          @if (shouldShowDefault(serviceAdvisor)) {
          <span class="advisor-default">default</span>
          }
        </mat-option>
        }
      </mat-select>

      @if (isInitialLoadComplete() && formTouched && resourcesForm.get('serviceadvisorIdControl')?.invalid &&
      resourcesForm.get('serviceadvisorIdControl')?.touched) {
      <mat-error i18n>Select a service advisor</mat-error>
      }
    </mat-form-field>
    
    @if (isLargeScreen()) {
    <div class="appointment-date-header" i18n>Select appointment date</div>

    @if (isLoading) {
      <div class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
        <p i18n>Loading available dates...</p>
      </div>
    } @else {
      @if (availableDates.length > 0) {
        <mat-card class="demo-inline-calendar-card">
          <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateSelected($event)" [dateFilter]="myFilter">
          </mat-calendar>
        </mat-card>
      } @else if (datesErrorMessage) {
        <div class="dates-error-message">{{ datesErrorMessage }}</div>
      } 
    }
    }

    @if (selectedDate && availableTimeslots.length > 0 && isLargeScreen()) {
    <div class="timeslots-header">
      <span class="appointment-time-header" i18n>Select appointment time</span>
    </div>
    <div class="timeslots-section">
      <div class="timeslots-container">
        <div class="timeslots-swiper" #swiperContainer [style.transform]="'translateX(' + (-currentPage * 100) + '%)'"
          (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
          @for (page of timeslotPages; track trackByIndex($index)) {
          <div class="timeslots-page">
            <div class="timeslots-grid">
              @for (timeslot of page; track trackByTimeslot($index, timeslot)) {
              <mat-chip class="timeslot-chip" [class.selected]="selectedTimeslot === timeslot"
                (click)="onTimeslotSelected(timeslot)">
                {{ timeslot }}
              </mat-chip>
              }
            </div>
          </div>
          }
        </div>

        @if (timeslotPages.length > 1) {
        <div class="pagination-dots">
          @for (page of timeslotPages; track trackByIndex($index)) {
          <div class="dot" [class.active]="currentPage === $index" (click)="goToPage($index)"></div>
          }
        </div>
        }
      </div>
    </div>
    }

    @if(!isLargeScreen()){
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label i18n>Appointment date</mat-label>
      <input matInput [matDatepicker]="picker" [matDatepickerFilter]="myFilter" formControlName="preferredDateControl"
        (dateChange)="onDateSelected($event.value)" [placeholder]="pickdate" readonly="readonly">
      <mat-hint>{{ getDateHint() }}</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      @if (isInitialLoadComplete() && formTouched && resourcesForm.get('preferredDateControl')?.invalid &&
      resourcesForm.get('preferredDateControl')?.touched) {
      <mat-error>{{pickappointment}}</mat-error>
      }
    </mat-form-field>
    }

    @if (selectedDate && availableTimeslots.length > 0 && !isLargeScreen()) {
    <div class="timeslots-section">
      <div class="timeslots-header">
        <span i18n>Available time slots</span>
      </div>

      <div class="timeslots-container">
        <div class="timeslots-swiper" #swiperContainer [style.transform]="'translateX(' + (-currentPage * 100) + '%)'"
          (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
          @for (page of timeslotPages; track trackByIndex($index)) {
          <div class="timeslots-page">
            <div class="timeslots-grid">
              @for (timeslot of page; track trackByTimeslot($index, timeslot)) {
              <mat-chip class="timeslot-chip" [class.selected]="selectedTimeslot === timeslot"
                (click)="onTimeslotSelected(timeslot)">
                {{ timeslot }}
              </mat-chip>
              }
            </div>
          </div>
          }
        </div>

        @if (timeslotPages.length > 1) {
        <div class="pagination-dots">
          @for (page of timeslotPages; track trackByIndex($index)) {
          <div class="dot" [class.active]="currentPage === $index" (click)="goToPage($index)"></div>
          }
        </div>
        }
      </div>
    </div>
    }

    @if (showDateWarning && isInitialLoadComplete() && formTouched && isLargeScreen()) {
    <div class="warning-message">
      <span class="warning-text">{{ pickappointment }}</span>
    </div>
    }
    @if (showTimeslotWarning && isInitialLoadComplete() && formTouched) {
    <div class="warning-message">
      <span class="warning-icon"><mat-icon>error</mat-icon></span>
      <span class="warning-text">{{ timeslotwarning }}</span>
    </div>
    }

    @if (isLargeScreen()) {
    <div class="selected-date-time">
      <div class="date-section">
        <div class="selected-date-header" i18n>Appointment date*</div>
        <div class="date-text">
          <mat-icon fontIcon="today"></mat-icon>
          <span class="date">
            {{ selectedDate ? (selectedDate | date:'MM/dd/yyyy') : '--/--/----' }}
          </span>
        </div>
      </div>

      <div class="time-section">
        <div class="selected-date-header" i18n>Appointment time*</div>
        <div class="time-text">
          <mat-icon fontIcon="schedule"></mat-icon>
          <span class="time">
            {{ selectedTimeslot ? selectedTimeslot : '--:--' }}
          </span>
        </div>
      </div>
    </div>
    }
  </form>
}
</div>